// defs
import { FLOW_TYPE } from "./constants";
import { CTA_TYPE } from "@payment-ui/interfaces/Card";

// helper
import { format } from "@swiggy-private/core-ui";

// constants
import { SLIDE_TO_PAY_AMOUNT } from "@payment-ui/constants/TurboPayment";

export const getPaymentParams = (
    prop: FLOW_TYPE,
): {
    saveCard: boolean;
} => {
    switch (prop) {
        case FLOW_TYPE.SECURED_CARD: {
            return { saveCard: true };
        }
        case FLOW_TYPE.NOT_TOKENIZED_CARD:
        default: {
            return { saveCard: false };
        }
    }
};

export const getCTASubLabel = (ctaType: CTA_TYPE, payableAmount?: string): string | undefined => {
    if (ctaType === CTA_TYPE.REGULAR && payableAmount) {
        return format(SLIDE_TO_PAY_AMOUNT, payableAmount);
    }
    return undefined;
};
